import React from 'react';
import { QuizQuestion, QuizHealthTip } from '../types/quiz';

interface HealthTipsProps {
  answers: boolean[];
  questions?: QuizQuestion[];
  tips?: QuizHealthTip[];
}

const HealthTipsComponent: React.FC<HealthTipsProps> = ({ answers, questions, tips }) => {
  if (!questions || !tips) return null;

  const unhealthyIndices = answers
    .map((isYes, index) => {
      if (index >= questions.length) return -1;
      const question = questions[index];
      const isUnhealthy = isYes ? question.yesScore < 0 : question.noScore < 0;
      return isUnhealthy ? index : -1;
    })
    .filter((i) => i !== -1);

  if (unhealthyIndices.length === 0) {
    return (
      <div style={{
        width: '100%',
        maxWidth: '500px',
        padding: '20px',
        margin: '20px 0',
        backgroundColor: '#e8f5e9',
        borderRadius: '16px',
        textAlign: 'center',
      }}>
        <p style={{ fontSize: '18px', color: '#2e7d32', fontWeight: 'bold' }}>
          🎉 모든 답변이 건강한 습관이에요! 지금처럼 유지하세요!
        </p>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', maxWidth: '500px', margin: '20px 0' }}>
      <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' }}>
        💡 맞춤 건강 개선 팁
      </p>
      {unhealthyIndices.slice(0, 5).map((idx) => {
        const tip = tips[idx];
        if (!tip) return null;
        return (
          <div
            key={idx}
            style={{
              backgroundColor: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '10px',
              textAlign: 'left',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            }}
          >
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#6a1b9a', marginBottom: '6px' }}>
              {tip.icon} {tip.question}
            </div>
            <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.5' }}>
              {tip.tip}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HealthTipsComponent;
